import { render, staticRenderFns } from "./CreateMaterialRequest.vue?vue&type=template&id=1341a39c"
import script from "./CreateMaterialRequest.vue?vue&type=script&lang=js"
export * from "./CreateMaterialRequest.vue?vue&type=script&lang=js"
import style0 from "./CreateMaterialRequest.vue?vue&type=style&index=0&id=1341a39c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports